import { makeAutoObservable } from 'mobx';

export class BurgerMenuStore {
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  toggle = () => {
    this.isOpen = !this.isOpen;
  };

  close = () => {
    this.isOpen = false;
  };

  open = () => {
    this.isOpen = true;
  };
}

export const burgerMenuStore = new BurgerMenuStore();